export function reMapGetEmployeesData(applianceJson1) {
  console.log(applianceJson1);

  let employyes_list = applianceJson1;

  const payload = {
    employees: employyes_list.reduce(function (map, obj) {
      map[obj.id] = obj;
      return map;
    }, {}),
  };

  return payload;
}
